// import React, { useEffect, useState } from "react";
// import { HiChevronDown } from "react-icons/hi";
// import { useStateContext } from "../../../../../contexts/ThemeContext";
// import SizeIcon from "../../../../../assets/smallcaps.png";
// import {ReactComponent as TextIcon} from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
// import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
// import { toast } from "react-hot-toast";
// import { useForm } from "react-hook-form";
// import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
// import useLocales from "../../../../../hooks/useLocales";

// // This Form component is responsible for add and edit Header Block

// const HeaderForm = ({
//   formType,
//   submitHandlerParent,
//   handleDelete,
//   isLoading,
//   preHeaderData,
// }) => {
//   const { translate } = useLocales();
//   const { setActiveMainPageNav } = useStateContext();
//   const [fontDropDown, setFontDropDown] = useState(false);
//   const [selectedFont, setSelectedFont] = useState(null);
//   useEffect(() => {
//     setActiveMainPageNav(true);
//     return () => {
//       setActiveMainPageNav(false);
//     };
//      // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const {
//     register,
//     handleSubmit,
//     formState: { errors },
//     setValue,
//     reset,
//   } = useForm();

//   useEffect(() => {
//     if (preHeaderData) {
//       setSelectedFont(preHeaderData?.coloum_type);
//       setValue("coloumnValue", preHeaderData?.coloum_value?.coloum_value);
//     }
//       // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [preHeaderData]);

//   const submitHandler = async (data) => {
//     if (selectedFont === "Header Size") {
//       toast.error("Please select a size");
//       return;
//     }
//     data.coloumnType = selectedFont;
//     data.columnName = "heading";
//     submitHandlerParent(data);
//   };

//   const deleteHandler = async (data) => {
//     if (formType === "add") {
//       reset();
//       setSelectedFont("Header Size");
//     } else {
//       handleDelete(data);
//     }
//   };

//   return (
//     <>
//       <div className="sm:mt-7 md:px-0 mt-10 mb-6 px-6">
//         <div className="border rounded-[10px] bg-light_bg_v5 p-[25px]">
//           <p className="text-small2_b sm:text-small1_bold mb-[20px] sm:mb-[25px] text-heading_color uppercase">
//             {" "}
//             {(formType === "edit" && translate(`edit_taxes.${formType}`)) ||
//               translate(`${formType}`)}{" "}
//             {translate("header_")}{" "}
//           </p>
//           <form onSubmit={handleSubmit(submitHandler)}>
//             <div className="mt-4">
//               <div>
//                 <div className="relative rounded-md bg-light_bg_v4 p-[13px] px-[14px] sm:px-[16.5px] flex justify-between items-center">
//                   <div
//                     onClick={() => setFontDropDown(!fontDropDown)}
//                     className="flex cursor-pointer items-center w-full"
//                   >
//                     <img className=" w-auto" src={SizeIcon} alt="" />
//                     <div className="sm:text-small1 text-small2 text-heading_color ps-2.5 w-full">
//                       {(selectedFont && selectedFont) ||
//                         translate("header_size")}
//                     </div>
//                   </div>
//                   <div
//                     onClick={() => setFontDropDown(!fontDropDown)}
//                     className="text-2xl cursor-pointer font-semibold text-gray-700 "
//                   >
//                     <HiChevronDown />
//                   </div>
//                   {fontDropDown && (
//                     <div className="absolute top-12 left-0 w-full z-50 p-[15px] bg-light_bg_v5 rounded-lg border flex flex-col">
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H1");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H1
//                       </div>
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H2");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H2
//                       </div>
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H3");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H3
//                       </div>
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H4");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H4
//                       </div>
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H5");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H5
//                       </div>
//                       <div
//                         onClick={() => {
//                           setSelectedFont("H6");
//                           setFontDropDown(false);
//                         }}
//                         className="px-[15px] py-[10px] text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
//                       >
//                         H6
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="mt-[5px] relative">
//                   <div className="absolute inset-y-0 h-full sm:ps-[16.5px] ps-[14px] flex justify-center items-center">
//                     <TextIcon />
//                   </div>
//                   <input
//                     type="text"
//                     {...register("coloumnValue", {
//                       required: translate("header_required"),
//                     })}
//                     id="heading"
//                     className={`rounded-md border bg-light_bg_v5 p-[13px] py-[5px] ps-10 sm:ps-11 px-[15px] sm:px-[16.5px] text-heading_color text-small2 sm:text-small1 focus:outline-none focus:ring-0  focus:placeholder:text-heading_color block w-full
//                     ${
//                       errors?.coloumnValue
//                         ? "border-state_color_error "
//                         : "border-light_bg_v2 focus:border-font_light_color"
//                     }`}
//                     placeholder={translate("enter_header")}
//                   />
//                 </div>
//                 {errors?.coloumnValue && (
//                   <small className="text-state_color_error text-small3">
//                     {errors?.coloumnValue?.message}
//                   </small>
//                 )}
//               </div>
//             </div>
//             <div className="flex mt-[26px] items-center justify-end">
//             <button
//             type="button"
//               onClick={() => deleteHandler()}
//               className="flex justify-center items-center"
//             >
//               <TrashIcon />
//               <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color">
//                 {translate("biolink_title.delete_cap")}
//               </p>
//             </button>

//               <ExtraSmallFilledButton
//                 name={`${translate("biolink_title.save_cap")}`}
//                 buttonType={"submit"}
//                 isLoading={isLoading}
//                 classes={"ms-3"}
//               />
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default HeaderForm;

import React, { useEffect, useState } from "react";
import { HiChevronDown } from "react-icons/hi";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import SizeIcon from "../../../../../assets/smallcaps.png";
import { ReactComponent as TextIcon } from "../../../../../assets/MainPage/addBlock/countDown/text.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/dashboard/link/trashIcon.svg";
import { ReactComponent as TrashIconDark } from "../../../../../assets/dashboard/link/trashIcon-dark.svg";
import { toast } from "react-hot-toast";
import { useForm } from "react-hook-form";
import ExtraSmallFilledButton from "../../../../../components/common/buttons/ExtraSmallFilledButton";
import useLocales from "../../../../../hooks/useLocales";
import TextEditor from "../addBlocks/TextEditor";
import { useSelector } from "react-redux";
import { ReactComponent as DownArrow } from "../../../../../assets/settingPage/arrow-down.svg";
import i18nForComponent from "../../../../../locales/component/i18nForComponent";
import { I18nextProvider } from "react-i18next";

// This Form component is responsible for add and edit Header Block

const HeaderForm = ({
  formType,
  submitHandlerParent,
  handleDelete,
  isLoading,
  preHeaderData,
}) => {
  const { darkMode } = useSelector((state) => state.theme);
  const { allLangs, tComponent, handleLanguageChange } = useLocales();

  const { setActiveMainPageNav } = useStateContext();
  const [fontDropDown, setFontDropDown] = useState(false);
  const [selectedFont, setSelectedFont] = useState(null);
  const [editorValue, setEditorValue] = useState("");

  const [selectReporterTypeDropDown, setSelectReporterTypeDropDown] =
    useState(false);
  const [selectedReporterType, setSelectedReporterType] = useState("English");
  const [selectedLang, setSelectedLang] = useState("en");

  const handleEditorChange = (value) => {
    setEditorValue(value);
  };

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (selectedLang) {
      handleLanguageChange(selectedLang);
    }
  }, [selectedLang]);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  useEffect(() => {
    if (preHeaderData) {
      setSelectedFont(preHeaderData?.coloum_type);
      setEditorValue(preHeaderData?.coloum_value?.coloum_value);
      setSelectedLang(preHeaderData?.language);
      const matchedLang = allLangs?.find(
        (lang) => lang.value === preHeaderData?.language
      );
      const shouldSetLang = matchedLang?.label;
      setSelectedReporterType(shouldSetLang);
      handleLanguageChange(preHeaderData?.language);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preHeaderData]);

  const submitHandler = async (data) => {
    if (editorValue === "") {
      toast.error("Please Type AnyThing");
      return;
    }

    data.coloumnType = "H1";
    data.columnName = "heading";
    data.coloumnValue = editorValue;
    data.language = selectedLang;
    submitHandlerParent(data);
  };

  const deleteHandler = async (data) => {
    if (formType === "add") {
      reset();
      setSelectedFont("Header Size");
    } else {
      handleDelete(data);
    }
  };

  const handleChangeLang = (newLang) => {
    handleLanguageChange(newLang);
  };

  return (
    <I18nextProvider i18n={i18nForComponent}>
      <>
        <div
          className="sm:mt-7 md:px-0 mt-10 mb-6 px-6"
          style={{
            direction: selectedLang === "ar" ? "rtl" : "ltr",
          }}
        >
          <div className="border rounded-[10px] bg-light_bg_v5 p-[25px] dark:bg-dark-secondary dark:border-color_dark">
            <div className="flex justify-between items-center mb-[20px] sm:mb-[25px]">
              <p className="text-small2_b sm:text-small1_bold text-heading_color dark:text-color_v1_dark uppercase">
                {formType === "edit" && tComponent(`texteditor.${formType}`)}
                {formType === "add" && tComponent(`texteditor.${formType}`)}
                &nbsp;
                {tComponent("texteditor.text")}
              </p>
              {formType === "add" && (
                <div className="flex items-center justify-center">
                  <div className="relative w-[115px] sm:w-[145px]">
                    <div
                      onClick={() => {
                        setSelectReporterTypeDropDown(
                          !selectReporterTypeDropDown
                        );
                      }}
                      className={`bg-light_bg_v4 capitalize p-[13px] text-small2 lg:text-body_copy2 rounded-md w-full flex justify-between items-center cursor-pointer`}
                    >
                      {selectedReporterType
                        ? selectedReporterType
                        : tComponent("texteditor.select_lang")}
                      <DownArrow />
                    </div>
                    {selectReporterTypeDropDown && (
                      <div className="absolute top-14 mb-20 left-0 w-full z-50 p-[7px] px-[10px] md:p-[15px] bg-light_bg_v5  rounded-lg border flex flex-col max-h-40 overflow-y-auto">
                        {allLangs?.map((item, i) => {
                          return (
                            <div
                              key={i}
                              onClick={() => {
                                setSelectedLang(item.value); // Set selected language code
                                setSelectedReporterType(item?.label);
                                setSelectReporterTypeDropDown(false);
                                handleChangeLang(item?.value);
                              }}
                              className="px-[10px] md:px-[15px] py-[7px] md:py-[10px] capitalize text-small2 lg:text-body_copy2 text-heading_color cursor-pointer hover:bg-light_bg_v4 rounded-md"
                            >
                              {item.label}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              )}
              {formType === "edit" && (
                <div
                  className={`w-[100px] bg-light_bg_v4 capitalize p-[10px] text-small2 lg:text-body_copy2 rounded-md flex justify-center items-center`}
                >
                  {selectedReporterType ? selectedReporterType : "English"}
                </div>
              )}
            </div>
            <form onSubmit={handleSubmit(submitHandler)}>
              <div className="mt-4">
                <div>
                  <div className="mt-[5px] relative">
                    <TextEditor
                      value={editorValue}
                      onChange={handleEditorChange}
                    />
                  </div>
                </div>
              </div>
              <div className="flex mt-[26px] items-center justify-end">
                <button
                  type="button"
                  onClick={() => deleteHandler()}
                  className="flex justify-center items-center"
                >
                  {darkMode ? <TrashIconDark /> : <TrashIcon />}
                  <p className="ps-1.5 pt-1 text-small3_b gray-700 text-heading_color dark:text-color_v1_dark">
                    {tComponent("texteditor.delete_cap")}
                  </p>
                </button>

                <ExtraSmallFilledButton
                  name={`${tComponent("texteditor.save_cap")}`}
                  buttonType={"submit"}
                  isLoading={isLoading}
                  classes={"ms-3"}
                />
              </div>
            </form>
          </div>
        </div>
      </>
    </I18nextProvider>
  );
};

export default HeaderForm;
